import app from 'flarum/forum/app';
import Component, { ComponentAttrs } from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';
import Button from 'flarum/common/components/Button';
import PaymentOptionsModal from './PaymentOptionsModal';
import type Mithril from 'mithril';
import Group from 'flarum/common/models/Group';

export interface ISubscribeCardAttrs extends ComponentAttrs {
  group: Group;
}

export default class SubscribeCard<CustomAttrs extends ISubscribeCardAttrs = ISubscribeCardAttrs> extends Component<CustomAttrs> {
  private group!: Group;
  private actor = app?.session?.user;

  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);

    this.group = this.attrs.group;
  }

  view() {
    return (
      <div className="SubscribeCard" style={this.group.color() ? { backgroundColor: this.group.color() } : ''}>
        <span className="icon">{icon(this.group.icon() || '')}</span>
        <h2 className="group">{this.group.namePlural()}</h2>
        <div className="description">{this.group.product?.attributes.description}</div>
        <div className="controls">{this.button()}</div>
      </div>
    );
  }

  button() {
    const actorGroups = this.actor?.groups() || [];

    const inGroup: boolean = actorGroups.find(group => {
        return group!.id() === this.group.id();
    }) !== undefined;

    return Button.component(
      {
        icon: inGroup ? 'fas fa-users' : 'fas fa-shopping-cart',
        className: 'Button',
        onclick: () => app.modal.show(PaymentOptionsModal, { for: this.group, product: this.group.product }),
        disabled: inGroup,
      },
      inGroup
        ? app.translator.trans('floxum-payments.forum.access-portal.subscribed')
        : app.translator.trans('floxum-payments.forum.access-portal.options')
    );
  }
}
